export default {
  GET: 'get',
  HEAD: 'head',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
  PATCH: 'patch'
};
